// extracted by mini-css-extract-plugin
module.exports = {"image":"_93444fe79c--image--Oo6am"};